import { createDecorator } from '../../platform/instantiation/common/instantiation.js';
const IViewDescriptorService = ( createDecorator('viewDescriptorService'));
export { IViewDescriptorService };
